export default { Visitor: 1, Agent: 11, Supervisor: 12, System: 13 };
